import { IChartEventBadgeProps } from '../utils'
import { getChartEventEarningSvgString } from './earnings'

export function getChartEventEarningsFutureSvgString(args: IChartEventBadgeProps) {
  return getChartEventEarningSvgString({ ...args, isFuture: true })
}
